// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Complementa InventoryPage.css: toolbar, tabla de acciones, drawer, pills */

.analytics-toolbar {
  flex-direction: column;
  align-items: stretch !important;
  gap: 12px;
}

.analytics-toolbar-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: flex-end;
}

/**
 * Inputs / selects alineados con Sitios (.sites-search-input, .sites-filter-select).
 * El inv-toolbar por defecto usa #111/#2a2a2a (Inventory); aquí forzamos la misma base que Sitios.
 */
.inventory-page .analytics-toolbar.inv-toolbar .inv-input,
.inventory-page .analytics-toolbar.inv-toolbar .inv-select {
  background: #0a0a0a;
  border: 1px solid #374151;
  color: #ffffff;
}

.inventory-page .analytics-toolbar.inv-toolbar .inv-input:focus,
.inventory-page .analytics-toolbar.inv-toolbar .inv-select:focus {
  border-color: #a61b34;
  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);
  outline: none;
}

.inventory-page .analytics-toolbar.inv-toolbar .inv-input::placeholder {
  color: #6b7280;
}

.analytics-search-btn {
  flex-shrink: 0;
  margin-top: auto;
}

.analytics-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12px;
  color: #9ca3af;
  min-width: 160px;
}

.analytics-field-grow {
  flex: 1 1;
  min-width: 200px;
}

.analytics-error {
  margin: 0;
  padding: 8px 12px;
  border-radius: 8px;
  background: rgba(239, 68, 68, 0.12);
  color: #fca5a5;
  font-size: 14px;
}

.analytics-th-sort {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  color: inherit;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  text-align: left;
  width: 100%;
  border-radius: 4px;
}

.analytics-th-sort:hover {
  color: #f87171;
}

.analytics-th-sort:focus-visible {
  outline: 2px solid rgba(248, 113, 113, 0.6);
  outline-offset: 2px;
}

.analytics-mono {
  font-family: ui-monospace, monospace;
  font-size: 13px;
}

.analytics-table-actions {
  flex-wrap: wrap;
  justify-content: flex-end;
  max-width: 220px;
  margin-left: auto;
}

.analytics-pill {
  display: inline-block;
  min-width: 1.75rem;
  padding: 4px 10px;
  border-radius: 12px;
  text-align: center;
  font-weight: 600;
  font-size: 12px;
}

.analytics-pill--low {
  background: rgba(34, 197, 94, 0.15);
  color: #22c55e;
}

.analytics-pill--mid {
  background: rgba(234, 179, 8, 0.15);
  color: #eab308;
}

.analytics-pill--high {
  background: rgba(239, 68, 68, 0.15);
  color: #f87171;
}

.analytics-linkish {
  background: none;
  border: none;
  color: #60a5fa;
  cursor: pointer;
  font-size: 13px;
  padding: 0;
}

.analytics-linkish:hover:not(:disabled) {
  text-decoration: underline;
}

.analytics-linkish:disabled {
  color: #6b7280;
  cursor: not-allowed;
}

.analytics-recording-hint {
  font-size: 11px;
  color: #9ca3af;
  line-height: 1.2;
  cursor: help;
  flex-basis: 100%;
  text-align: right;
}

.analytics-recording-footnote {
  margin: 12px 0 0;
  font-size: 13px;
  color: #fca5a5;
  line-height: 1.4;
}

.analytics-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 24px 40px 40px;
  color: #9ca3af;
  font-size: 14px;
}

/* Mismo rojo que ítems activos del menú lateral (#A61B34 / #8B1528) */
.analytics-pagination .btn-refresh {
  background: linear-gradient(135deg, #a61b34 0%, #8b1528 100%);
  color: #ffffff;
  min-width: 44px;
  padding: 10px 16px;
  box-shadow: 0 2px 8px rgba(166, 27, 52, 0.25);
}

.analytics-pagination .btn-refresh:hover:not(:disabled) {
  background: linear-gradient(135deg, #c42d44 0%, #a61b34 100%);
  box-shadow: 0 4px 12px rgba(166, 27, 52, 0.4);
  transform: translateY(-2px);
}

.analytics-pagination .btn-refresh:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.analytics-page-meta {
  min-width: 200px;
  text-align: center;
  color: #d1d5db;
}

.analytics-table-loading-cell {
  text-align: center;
  vertical-align: middle;
  padding: 0 !important;
  border: none !important;
}

.analytics-drawer-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 220px;
}

.analytics-detail-image-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  background: #0a0a0a;
  border-radius: 8px;
}

.analytics-detail-image-spinner .xtam-spinner--small {
  padding: 32px 16px;
}

.analytics-drawer-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 12000;
  display: flex;
  justify-content: flex-end;
}

.analytics-drawer {
  width: min(440px, 100%);
  background: linear-gradient(195deg, #1c1c1c 0%, #121212 45%, #0e0e0e 100%);
  border-left: 1px solid #333333;
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.55);
  overflow-y: auto;
  animation: analytics-drawer-in 0.2s ease-out;
}

@keyframes analytics-drawer-in {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.analytics-drawer-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  border-bottom: 1px solid #333333;
}

.analytics-drawer-head h2 {
  margin: 0;
  font-size: 1.1rem;
  color: #fff;
}

.analytics-icon-btn {
  background: none;
  border: none;
  color: #b0b0b0;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
}

.analytics-icon-btn:hover {
  color: #f3f4f6;
  background: #3a3a3a;
}

.analytics-drawer-body {
  padding: 16px 18px 24px;
  color: #e8e8e8;
}

.analytics-dl {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 6px 14px;
  margin: 0 0 16px;
  font-size: 14px;
}

.analytics-dl dt {
  color: #a3a3a3;
  margin: 0;
}

.analytics-dl dd {
  margin: 0;
}

.analytics-muted {
  color: #a3a3a3;
  font-size: 13px;
}

.analytics-detail-image {
  margin: 12px 0 16px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #333333;
}

.analytics-detail-image img {
  display: block;
  width: 100%;
  height: auto;
  max-height: 280px;
  object-fit: contain;
  background: #000;
}

.analytics-detail-image-skeleton {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  background: linear-gradient(90deg, #1a1a1a 0%, #2c2c2c 50%, #1a1a1a 100%);
  background-size: 200% 100%;
  animation: analytics-image-shimmer 1.2s ease-in-out infinite;
}

@keyframes analytics-image-shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

.analytics-detail-image-skeleton-label {
  font-size: 13px;
  color: #9ca3af;
}

.analytics-detections-title {
  font-size: 0.95rem;
  margin: 16px 0 8px;
  color: #fff;
}

.analytics-detections-pending {
  padding: 8px 0 12px;
}

.analytics-detections {
  margin: 0;
  padding-left: 18px;
  color: #d0d0d0;
  font-size: 13px;
  line-height: 1.5;
}

.analytics-drawer-footer {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #333333;
}

.analytics-drawer-primary {
  width: 100%;
  justify-content: center;
}

/* Pestañas Tabla / Galería */
.analytics-subtabs {
  display: flex;
  gap: 8px;
  padding: 0 40px 16px;
  border-bottom: 1px solid #2e2e2e;
}

.analytics-subtab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: 8px;
  border: 1px solid #374151;
  background: #0a0a0a;
  color: #9ca3af;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition:
    color 0.15s,
    border-color 0.15s,
    background 0.15s;
}

.analytics-subtab:hover {
  color: #ffffff;
  border-color: #4b5563;
  background: #0a0a0a;
}

.analytics-subtab--active {
  color: #fff;
  border-color: #dc2626;
  background: rgba(220, 38, 38, 0.12);
}

.analytics-subtab:focus-visible {
  outline: 2px solid rgba(248, 113, 113, 0.6);
  outline-offset: 2px;
}

/* Galería: filtros rápidos */
.analytics-gallery-toolbar {
  margin-top: 0;
}

.analytics-gallery-quick-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 16px;
  width: 100%;
}

.analytics-gallery-quick-label {
  font-size: 12px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.analytics-quick-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.analytics-quick-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid #374151;
  background: #0a0a0a;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition:
    border-color 0.15s,
    background 0.15s,
    color 0.15s;
}

.analytics-quick-chip:hover {
  border-color: #4b5563;
  color: #ffffff;
  background: #0a0a0a;
}

.analytics-quick-chip--active {
  border-color: #dc2626;
  background: rgba(220, 38, 38, 0.15);
  color: #fca5a5;
}

.analytics-quick-chip:focus-visible {
  outline: 2px solid rgba(248, 113, 113, 0.55);
  outline-offset: 2px;
}

.analytics-gallery-vehicle-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  border-top: 1px solid #2e2e2e;
  margin-top: 8px;
  padding-top: 12px;
}

.analytics-gallery-grid-wrap {
  padding: 20px 40px 8px;
}

.analytics-gallery-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 24px 20px 48px;
  min-height: 240px;
}

.analytics-gallery-empty {
  padding: 48px 24px;
}

.analytics-gallery-grid {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 20px;
}

.analytics-gallery-card {
  margin: 0;
  padding: 0;
  background: #0c0c0c;
  border: 1px solid #353535;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.analytics-gallery-thumb-wrap {
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  border: none;
  background: #000;
  cursor: pointer;
  text-align: left;
}

.analytics-gallery-thumb-wrap:focus-visible {
  outline: 2px solid #dc2626;
  outline-offset: -2px;
}

.analytics-gallery-thumb-frame {
  position: relative;
  aspect-ratio: 16 / 10;
  width: 100%;
  background: #0a0a0a;
}

.analytics-gallery-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.analytics-gallery-thumb-skeleton {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, #1a1a1a 0%, #2c2c2c 50%, #1a1a1a 100%);
  background-size: 200% 100%;
  animation: analytics-image-shimmer 1.2s ease-in-out infinite;
}

.analytics-gallery-thumb-placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #6b7280;
  font-size: 12px;
}

.analytics-gallery-thumb-placeholder--error {
  color: #9ca3af;
}

.analytics-gallery-card-body {
  padding: 12px 14px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: linear-gradient(180deg, #242424 0%, #181818 42%, #121212 100%);
  border-top: 1px solid #2f2f2f;
}

.analytics-gallery-card-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  line-height: 1.35;
}

.analytics-gallery-site {
  font-weight: 700;
  color: #f9fafb;
}

.analytics-gallery-camera {
  color: #b3b3b3;
}

.analytics-gallery-time {
  color: #d4d4d4;
  font-variant-numeric: tabular-nums;
}

/* Evita tonos azulados en metadatos (p. ej. herencia o estilos de \`time\`) */
.analytics-gallery-card time.analytics-gallery-time {
  color: #d4d4d4;
}

.analytics-gallery-card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  align-items: center;
}

/* Galería: acciones en rojo (sin azul #60a5fa del .analytics-linkish global) */
.analytics-gallery-card-actions .analytics-linkish {
  color: #f87171;
}

.analytics-gallery-card-actions .analytics-linkish:hover:not(:disabled) {
  color: #fca5a5;
  text-decoration: underline;
}

.analytics-gallery-card-actions .analytics-linkish svg {
  color: inherit;
  stroke: currentColor;
}

.analytics-gallery-card-actions .analytics-linkish:disabled {
  color: #6b7280;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AnalyticsPage.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;;;EAGE;AACF;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA,sEAAsE;AACtE;EACE,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,0EAA0E;EAC1E,8BAA8B;EAC9B,2CAA2C;EAC3C,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yEAAyE;EACzE,0BAA0B;EAC1B,4DAA4D;AAC9D;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;;oBAGkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;;eAGa;AACf;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,UAAU;EACV,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,yEAAyE;EACzE,0BAA0B;EAC1B,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0EAA0E;EAC1E,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA,4EAA4E;AAC5E;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Complementa InventoryPage.css: toolbar, tabla de acciones, drawer, pills */\n\n.analytics-toolbar {\n  flex-direction: column;\n  align-items: stretch !important;\n  gap: 12px;\n}\n\n.analytics-toolbar-fields {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: flex-end;\n}\n\n/**\n * Inputs / selects alineados con Sitios (.sites-search-input, .sites-filter-select).\n * El inv-toolbar por defecto usa #111/#2a2a2a (Inventory); aquí forzamos la misma base que Sitios.\n */\n.inventory-page .analytics-toolbar.inv-toolbar .inv-input,\n.inventory-page .analytics-toolbar.inv-toolbar .inv-select {\n  background: #0a0a0a;\n  border: 1px solid #374151;\n  color: #ffffff;\n}\n\n.inventory-page .analytics-toolbar.inv-toolbar .inv-input:focus,\n.inventory-page .analytics-toolbar.inv-toolbar .inv-select:focus {\n  border-color: #a61b34;\n  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);\n  outline: none;\n}\n\n.inventory-page .analytics-toolbar.inv-toolbar .inv-input::placeholder {\n  color: #6b7280;\n}\n\n.analytics-search-btn {\n  flex-shrink: 0;\n  margin-top: auto;\n}\n\n.analytics-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 12px;\n  color: #9ca3af;\n  min-width: 160px;\n}\n\n.analytics-field-grow {\n  flex: 1;\n  min-width: 200px;\n}\n\n.analytics-error {\n  margin: 0;\n  padding: 8px 12px;\n  border-radius: 8px;\n  background: rgba(239, 68, 68, 0.12);\n  color: #fca5a5;\n  font-size: 14px;\n}\n\n.analytics-th-sort {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  color: inherit;\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n  text-align: left;\n  width: 100%;\n  border-radius: 4px;\n}\n\n.analytics-th-sort:hover {\n  color: #f87171;\n}\n\n.analytics-th-sort:focus-visible {\n  outline: 2px solid rgba(248, 113, 113, 0.6);\n  outline-offset: 2px;\n}\n\n.analytics-mono {\n  font-family: ui-monospace, monospace;\n  font-size: 13px;\n}\n\n.analytics-table-actions {\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  max-width: 220px;\n  margin-left: auto;\n}\n\n.analytics-pill {\n  display: inline-block;\n  min-width: 1.75rem;\n  padding: 4px 10px;\n  border-radius: 12px;\n  text-align: center;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.analytics-pill--low {\n  background: rgba(34, 197, 94, 0.15);\n  color: #22c55e;\n}\n\n.analytics-pill--mid {\n  background: rgba(234, 179, 8, 0.15);\n  color: #eab308;\n}\n\n.analytics-pill--high {\n  background: rgba(239, 68, 68, 0.15);\n  color: #f87171;\n}\n\n.analytics-linkish {\n  background: none;\n  border: none;\n  color: #60a5fa;\n  cursor: pointer;\n  font-size: 13px;\n  padding: 0;\n}\n\n.analytics-linkish:hover:not(:disabled) {\n  text-decoration: underline;\n}\n\n.analytics-linkish:disabled {\n  color: #6b7280;\n  cursor: not-allowed;\n}\n\n.analytics-recording-hint {\n  font-size: 11px;\n  color: #9ca3af;\n  line-height: 1.2;\n  cursor: help;\n  flex-basis: 100%;\n  text-align: right;\n}\n\n.analytics-recording-footnote {\n  margin: 12px 0 0;\n  font-size: 13px;\n  color: #fca5a5;\n  line-height: 1.4;\n}\n\n.analytics-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  padding: 24px 40px 40px;\n  color: #9ca3af;\n  font-size: 14px;\n}\n\n/* Mismo rojo que ítems activos del menú lateral (#A61B34 / #8B1528) */\n.analytics-pagination .btn-refresh {\n  background: linear-gradient(135deg, #a61b34 0%, #8b1528 100%);\n  color: #ffffff;\n  min-width: 44px;\n  padding: 10px 16px;\n  box-shadow: 0 2px 8px rgba(166, 27, 52, 0.25);\n}\n\n.analytics-pagination .btn-refresh:hover:not(:disabled) {\n  background: linear-gradient(135deg, #c42d44 0%, #a61b34 100%);\n  box-shadow: 0 4px 12px rgba(166, 27, 52, 0.4);\n  transform: translateY(-2px);\n}\n\n.analytics-pagination .btn-refresh:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.analytics-page-meta {\n  min-width: 200px;\n  text-align: center;\n  color: #d1d5db;\n}\n\n.analytics-table-loading-cell {\n  text-align: center;\n  vertical-align: middle;\n  padding: 0 !important;\n  border: none !important;\n}\n\n.analytics-drawer-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 220px;\n}\n\n.analytics-detail-image-spinner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  background: #0a0a0a;\n  border-radius: 8px;\n}\n\n.analytics-detail-image-spinner .xtam-spinner--small {\n  padding: 32px 16px;\n}\n\n.analytics-drawer-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  z-index: 12000;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.analytics-drawer {\n  width: min(440px, 100%);\n  background: linear-gradient(195deg, #1c1c1c 0%, #121212 45%, #0e0e0e 100%);\n  border-left: 1px solid #333333;\n  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.55);\n  overflow-y: auto;\n  animation: analytics-drawer-in 0.2s ease-out;\n}\n\n@keyframes analytics-drawer-in {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n.analytics-drawer-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 18px;\n  border-bottom: 1px solid #333333;\n}\n\n.analytics-drawer-head h2 {\n  margin: 0;\n  font-size: 1.1rem;\n  color: #fff;\n}\n\n.analytics-icon-btn {\n  background: none;\n  border: none;\n  color: #b0b0b0;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n}\n\n.analytics-icon-btn:hover {\n  color: #f3f4f6;\n  background: #3a3a3a;\n}\n\n.analytics-drawer-body {\n  padding: 16px 18px 24px;\n  color: #e8e8e8;\n}\n\n.analytics-dl {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 6px 14px;\n  margin: 0 0 16px;\n  font-size: 14px;\n}\n\n.analytics-dl dt {\n  color: #a3a3a3;\n  margin: 0;\n}\n\n.analytics-dl dd {\n  margin: 0;\n}\n\n.analytics-muted {\n  color: #a3a3a3;\n  font-size: 13px;\n}\n\n.analytics-detail-image {\n  margin: 12px 0 16px;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #333333;\n}\n\n.analytics-detail-image img {\n  display: block;\n  width: 100%;\n  height: auto;\n  max-height: 280px;\n  object-fit: contain;\n  background: #000;\n}\n\n.analytics-detail-image-skeleton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  background: linear-gradient(90deg, #1a1a1a 0%, #2c2c2c 50%, #1a1a1a 100%);\n  background-size: 200% 100%;\n  animation: analytics-image-shimmer 1.2s ease-in-out infinite;\n}\n\n@keyframes analytics-image-shimmer {\n  0% {\n    background-position: 100% 0;\n  }\n  100% {\n    background-position: -100% 0;\n  }\n}\n\n.analytics-detail-image-skeleton-label {\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n.analytics-detections-title {\n  font-size: 0.95rem;\n  margin: 16px 0 8px;\n  color: #fff;\n}\n\n.analytics-detections-pending {\n  padding: 8px 0 12px;\n}\n\n.analytics-detections {\n  margin: 0;\n  padding-left: 18px;\n  color: #d0d0d0;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.analytics-drawer-footer {\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid #333333;\n}\n\n.analytics-drawer-primary {\n  width: 100%;\n  justify-content: center;\n}\n\n/* Pestañas Tabla / Galería */\n.analytics-subtabs {\n  display: flex;\n  gap: 8px;\n  padding: 0 40px 16px;\n  border-bottom: 1px solid #2e2e2e;\n}\n\n.analytics-subtab {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  border-radius: 8px;\n  border: 1px solid #374151;\n  background: #0a0a0a;\n  color: #9ca3af;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    color 0.15s,\n    border-color 0.15s,\n    background 0.15s;\n}\n\n.analytics-subtab:hover {\n  color: #ffffff;\n  border-color: #4b5563;\n  background: #0a0a0a;\n}\n\n.analytics-subtab--active {\n  color: #fff;\n  border-color: #dc2626;\n  background: rgba(220, 38, 38, 0.12);\n}\n\n.analytics-subtab:focus-visible {\n  outline: 2px solid rgba(248, 113, 113, 0.6);\n  outline-offset: 2px;\n}\n\n/* Galería: filtros rápidos */\n.analytics-gallery-toolbar {\n  margin-top: 0;\n}\n\n.analytics-gallery-quick-filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px 16px;\n  width: 100%;\n}\n\n.analytics-gallery-quick-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.analytics-quick-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.analytics-quick-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border-radius: 8px;\n  border: 1px solid #374151;\n  background: #0a0a0a;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    border-color 0.15s,\n    background 0.15s,\n    color 0.15s;\n}\n\n.analytics-quick-chip:hover {\n  border-color: #4b5563;\n  color: #ffffff;\n  background: #0a0a0a;\n}\n\n.analytics-quick-chip--active {\n  border-color: #dc2626;\n  background: rgba(220, 38, 38, 0.15);\n  color: #fca5a5;\n}\n\n.analytics-quick-chip:focus-visible {\n  outline: 2px solid rgba(248, 113, 113, 0.55);\n  outline-offset: 2px;\n}\n\n.analytics-gallery-vehicle-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  width: 100%;\n  border-top: 1px solid #2e2e2e;\n  margin-top: 8px;\n  padding-top: 12px;\n}\n\n.analytics-gallery-grid-wrap {\n  padding: 20px 40px 8px;\n}\n\n.analytics-gallery-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  padding: 24px 20px 48px;\n  min-height: 240px;\n}\n\n.analytics-gallery-empty {\n  padding: 48px 24px;\n}\n\n.analytics-gallery-grid {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 20px;\n}\n\n.analytics-gallery-card {\n  margin: 0;\n  padding: 0;\n  background: #0c0c0c;\n  border: 1px solid #353535;\n  border-radius: 12px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.analytics-gallery-thumb-wrap {\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  border: none;\n  background: #000;\n  cursor: pointer;\n  text-align: left;\n}\n\n.analytics-gallery-thumb-wrap:focus-visible {\n  outline: 2px solid #dc2626;\n  outline-offset: -2px;\n}\n\n.analytics-gallery-thumb-frame {\n  position: relative;\n  aspect-ratio: 16 / 10;\n  width: 100%;\n  background: #0a0a0a;\n}\n\n.analytics-gallery-thumb-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.analytics-gallery-thumb-skeleton {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(90deg, #1a1a1a 0%, #2c2c2c 50%, #1a1a1a 100%);\n  background-size: 200% 100%;\n  animation: analytics-image-shimmer 1.2s ease-in-out infinite;\n}\n\n.analytics-gallery-thumb-placeholder {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: #6b7280;\n  font-size: 12px;\n}\n\n.analytics-gallery-thumb-placeholder--error {\n  color: #9ca3af;\n}\n\n.analytics-gallery-card-body {\n  padding: 12px 14px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  background: linear-gradient(180deg, #242424 0%, #181818 42%, #121212 100%);\n  border-top: 1px solid #2f2f2f;\n}\n\n.analytics-gallery-card-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 13px;\n  line-height: 1.35;\n}\n\n.analytics-gallery-site {\n  font-weight: 700;\n  color: #f9fafb;\n}\n\n.analytics-gallery-camera {\n  color: #b3b3b3;\n}\n\n.analytics-gallery-time {\n  color: #d4d4d4;\n  font-variant-numeric: tabular-nums;\n}\n\n/* Evita tonos azulados en metadatos (p. ej. herencia o estilos de `time`) */\n.analytics-gallery-card time.analytics-gallery-time {\n  color: #d4d4d4;\n}\n\n.analytics-gallery-card-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 14px;\n  align-items: center;\n}\n\n/* Galería: acciones en rojo (sin azul #60a5fa del .analytics-linkish global) */\n.analytics-gallery-card-actions .analytics-linkish {\n  color: #f87171;\n}\n\n.analytics-gallery-card-actions .analytics-linkish:hover:not(:disabled) {\n  color: #fca5a5;\n  text-decoration: underline;\n}\n\n.analytics-gallery-card-actions .analytics-linkish svg {\n  color: inherit;\n  stroke: currentColor;\n}\n\n.analytics-gallery-card-actions .analytics-linkish:disabled {\n  color: #6b7280;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
